module.exports = __webpack_public_path__ + "static/media/dp.c317e112.svg";